import { Link } from "react-router-dom";
import type { MovieCast } from "@/mocks/movies";

export default function CastList({ cast }: { cast: MovieCast[] }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {cast.map((c) => (
        <Link
          key={c.name + c.role}
          to={`/search?q=${encodeURIComponent(c.name)}`}
          className="group rounded-lg bg-background-900/70 border border-background-800 p-3 text-center hover:border-primary-700 transition-colors"
        >
          <div className="w-20 h-20 mx-auto rounded-full overflow-hidden bg-background-800">
            <img
              src={c.avatar}
              alt={`演员 ${c.name}`}
              title={`${c.name} 演员资料`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <p className="mt-3 text-sm text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-1">
            {c.name}
          </p>
          <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{c.role}</p>
        </Link>
      ))}
    </div>
  );
}